module.exports = __webpack_public_path__ + "img/Komisaris-Utama-Bahrodji-new.d7e9f2e4.jpg";